export default __webpack_public_path__ + "static/media/videocam_off.eab333cc.svg";